import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useState } from 'react';

export type RenameProjectFormProps = {
	currentName: string;
	isSubmitting?: boolean;
	onCancel: () => void;
	onSubmit: (name: string) => void;
};

export function RenameProjectForm({ currentName, isSubmitting = false, onCancel, onSubmit }: RenameProjectFormProps) {
	const [name, setName] = useState<string>(currentName);

	const trimmedName = name.trim();
	const isUnchanged = trimmedName === currentName.trim();
	const isValid = trimmedName !== '' && !isUnchanged;

	const handleSubmit = () => {
		if (!isValid || isSubmitting) {
			return;
		}
		onSubmit(trimmedName);
	};

	return (
		<div className='flex w-80 flex-col gap-3 px-3 py-3'>
			<TextField
				label='Project name'
				value={name}
				onChange={(event) => setName(event.target.value)}
				onKeyDown={(event) => {
					if (event.key === 'Enter') {
						event.preventDefault();
						handleSubmit();
					}
				}}
				size='small'
				fullWidth
				autoFocus
			/>

			<div className='flex justify-end gap-2'>
				<Button variant='outlined' size='small' onClick={onCancel} disabled={isSubmitting}>
					<span>Cancel</span>
				</Button>
				<Button
					variant='contained'
					size='small'
					onClick={handleSubmit}
					disabled={!isValid || isSubmitting}
					loading={isSubmitting}
				>
					<span>Save</span>
				</Button>
			</div>
		</div>
	);
}
